module.exports = __webpack_public_path__ + "static/media/SMARISCOS_MENU-normal.833947be.png";